(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            console.log(text);
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');
              let cardHeight = parseInt(sameCard.clientHeight);
              let topValue = cardHeight / 2 + 5;
              let cardTopCSS = "calc(50% - "+topValue+'px)';
              let swiperContainer = document.querySelector('.product-recommendations .swiper');
              let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
              let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
              swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
              swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-banner"] && !Shopify.designMode) return;
  try {
    
class UspBannerSlider {
  constructor(el) {
    this.sectionEl = el;
    if (!this.sectionEl) return;

    this.wrapper = this.sectionEl.querySelector('.usp-banner__wrapper');
    this.container = this.sectionEl.querySelector('.usp-banner__container');
    this.slides = this.sectionEl.querySelectorAll('.usp-banner__slide');
    this.toggleButton = this.sectionEl.querySelector('.usp-banner__toggle');
    this.closeButton = this.sectionEl.querySelector('.usp-banner__close-button');
    this.overlay = this.sectionEl.querySelector('.usp-banner__overlay');

    this.currentIndex = 0;
    this.slideInterval = null;
    const speedSec = parseFloat(this.wrapper?.dataset.autocycleSpeed) || 2.5;
    this.pauseDuration = Math.max(1000, speedSec * 1000);
    this.animationDuration = 500;

    this.lastScrollTop = 0;
    this.scrollThreshold = 50;
    this.isExpanded = false;
    this.isAnimating = false;
    this.expandedScrollTop = 0;
    this._scrollTicking = false;

    this._onScroll = () => this.handleScroll();
    this._onResize = () => { if (this.isExpanded) this.adjustForViewport(); };
    this._onDocClick = (e) => {
      if (this.isExpanded && !this.sectionEl.contains(e.target)) this.closeExpanded();
    };
    this._onDocKeydown = (e) => {
      if (e.key === 'Escape') this.closeExpanded();
    };

    this.init();
  }

  init() {
    this.attachEventListeners(this.slides.length > 0);

    // Start the slideshow if there's more than one slide
    if (this.slides.length > 1) {
      this.startSlideshow();
    } else if (this.slides.length === 1) {
      // If only one slide, just show it statically
      this.slides[0].classList.add('is-active');
    }
  }

  // --- New Slideshow Logic ---
  startSlideshow() {
    // Initially display the first slide without animation
    this.slides[this.currentIndex].classList.add('is-active');
    // Start the cycle after the initial 5-second pause
    this.slideInterval = setTimeout(() => this.showNextSlide(), this.pauseDuration);
  }

  showNextSlide() {
    if (this.isExpanded) return; // Slideshow is paused when expanded

    const currentSlide = this.slides[this.currentIndex];
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    const nextSlide = this.slides[this.currentIndex];

    // Animate out the current slide
    currentSlide.classList.remove('is-active');
    currentSlide.classList.add('is-exiting');

    // Animate in the next slide
    nextSlide.classList.add('is-entering');

    // After animation, clean up classes. The new slide becomes the resting "active" slide.
    setTimeout(() => {
      currentSlide.classList.remove('is-exiting');
      nextSlide.classList.remove('is-entering');
      nextSlide.classList.add('is-active');
    }, this.animationDuration);

    // Schedule the NEXT transition after this animation completes AND the pause elapses.
    this.slideInterval = setTimeout(() => this.showNextSlide(), this.animationDuration + this.pauseDuration);
  }

  pauseSlideshow() {
    clearTimeout(this.slideInterval);
  }

  resumeSlideshow() {
    // Clear any residual timer and restart the cycle
    clearTimeout(this.slideInterval);
    if (this.slides.length > 1 && !this.isExpanded) {
      this.slideInterval = setTimeout(() => this.showNextSlide(), this.pauseDuration);
    }
  }

  // --- Retained Expand/Collapse Logic ---
  attachEventListeners(hasContent) {
    if (hasContent) {
      this.container.addEventListener('click', (e) => {
        if (!e.target.closest('.usp-banner__toggle')) this.toggleExpand();
      });
      this.toggleButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleExpand();
      });
      this.closeButton.addEventListener('click', () => this.closeExpanded());
      this.overlay.addEventListener('click', () => this.closeExpanded());
      this.container.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleExpand();
        }
      });
      this.container.setAttribute('tabindex', '0');
      this.container.setAttribute('role', 'button');
      this.container.setAttribute('aria-label', 'Toggle USP details');
    }
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
  }

  bindExpandedDocumentListeners() {
    document.addEventListener('click', this._onDocClick);
    document.addEventListener('keydown', this._onDocKeydown);
  }

  unbindExpandedDocumentListeners() {
    document.removeEventListener('click', this._onDocClick);
    document.removeEventListener('keydown', this._onDocKeydown);
  }

  toggleExpand() {
    if (this.isAnimating) return;
    this.isExpanded ? this.closeExpanded() : this.openExpanded();
  }

  openExpanded() {
    if (this.isAnimating) return;
    this.isAnimating = true;
    this.isExpanded = true;
    this.pauseSlideshow();
    this.bindExpandedDocumentListeners();
    this.expandedScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.sectionEl.classList.add('is-expanding');
    this.toggleButton.setAttribute('aria-expanded', 'true');
    if (window.innerWidth <= 768) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.expandedScrollTop}px`;
      document.body.style.width = '100%';
    }
    setTimeout(() => {
      this.sectionEl.classList.remove('is-expanding');
      this.sectionEl.classList.add('is-expanded');
      this.isAnimating = false;
    }, 400);
  }

  closeExpanded() {
    if (this.isAnimating || !this.isExpanded) return;
    this.isAnimating = true;
    this.isExpanded = false;
    this.unbindExpandedDocumentListeners();
    this.sectionEl.classList.remove('is-expanded');
    this.toggleButton.setAttribute('aria-expanded', 'false');
    if (window.innerWidth <= 768) {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.overflow = '';
      document.body.style.width = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
    setTimeout(() => {
      this.isAnimating = false;
      this.resumeSlideshow(); // RESUME slideshow when details close
    }, 400);
  }

  handleScroll() {
    if (this._scrollTicking) return;
    this._scrollTicking = true;
    requestAnimationFrame(() => {
      this._scrollTicking = false;
      this.handleScrollFrame();
    });
  }

  handleScrollFrame() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.isExpanded) {
      const scrollDifference = Math.abs(currentScrollTop - this.expandedScrollTop);
      if (scrollDifference > this.scrollThreshold) this.closeExpanded();
      return;
    }
    if (currentScrollTop > this.lastScrollTop && currentScrollTop > 100) {
      this.sectionEl.classList.add('hidden-on-scroll');
    } else {
      this.sectionEl.classList.remove('hidden-on-scroll');
    }
    this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }

  adjustForViewport() {
    const viewportWidth = window.innerWidth;
    const expandedContent = this.sectionEl.querySelector('.usp-banner__expanded-content');
    if (viewportWidth <= 374) expandedContent.style.fontSize = '12px';
    else if (viewportWidth <= 413) expandedContent.style.fontSize = '12px';
    else expandedContent.style.fontSize = '';
  }
}

function initUspBannerSections(root = document) {
  root.querySelectorAll('.usp-banner__outer-wrapper').forEach((el) => {
    if (!el.dataset.uspBannerInit) {
      el.dataset.uspBannerInit = 'true';
      new UspBannerSlider(el);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initUspBannerSections());
} else {
  initUspBannerSections();
}

document.addEventListener('shopify:section:load', (e) => {
  initUspBannerSections(e.target);
});

  } catch(e) { console.error(e); }
})();
})();
